import React from 'react';
import { useDispatch } from 'react-redux';

import { TabsView, TextView } from 'components';
import ButtonViewV3 from 'components/ButtonViewV3/ButtonViewV3';
import { CoreModal } from 'components/ModalViewV3';
import useChannelDetails from 'hooks/useChannelDetails';
import {
  onTemplateTypeChange,
  resetEmailContent,
  updateEmailContentFromBasicToHtml,
} from 'redux/content/content.slice';

const tableTabs: React.ComponentProps<typeof TabsView>['tabItems'] = [
  {
    key: 'Basic',
    title: 'Basic',
    children: '',
  },
  {
    key: 'HTML',
    title: 'HTML',
    children: '',
  },
];
const HtmlSwitchForEmail = ({ index }: { index: number }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const { channel } = useChannelDetails();
  const [activeTab, setActiveTab] = React.useState('Basic');
  const dispatch = useDispatch();

  if (channel?.toLowerCase() !== 'email') return null;

  return (
    <>
      <div>
        <TabsView
          activeKey={activeTab}
          tabItems={tableTabs}
          onTabClick={(tab) => {
            if (tab === 'Basic') {
              return setIsModalVisible(true);
            }
            dispatch(
              onTemplateTypeChange({
                templateType: 'HTML',
                contentIndex: index,
              })
            );
            dispatch(updateEmailContentFromBasicToHtml());
            setActiveTab(tab);
          }}
        />
      </div>
      <CoreModal
        open={isModalVisible}
        onDismiss={() => setIsModalVisible(false)}
        onModalClose={() => setIsModalVisible(false)}
      >
        <div className="flex flex-col items-center pt-[36px] gap-4">
          <div className=" flex flex-col items-center gap-2">
            <TextView
              color="#101828"
              weight="700"
              size={16}
              fontStyle="normal"
              lineHeight={24}
              text={'Switch to Basic?'}
            />
            <TextView
              color="#475467"
              weight="400"
              size={14}
              fontStyle="normal"
              lineHeight={20}
              text="Your current updates will not be saved if you choose Basic. Switch anyway?"
            />
          </div>
          <div className="flex gap-2 px-6 items-center">
            <div className="w-full">
              <ButtonViewV3
                variant="tertiary"
                label={`Don't switch`}
                onClick={() => {
                  setActiveTab('HTML');
                  setIsModalVisible(false);
                }}
              />
            </div>
            <div className="w-[280px]">
              <ButtonViewV3
                label={'Switch to Basic'}
                onClick={() => {
                  setIsModalVisible(false);
                  setActiveTab('Basic');
                  dispatch(resetEmailContent());
                  dispatch(
                    onTemplateTypeChange({
                      templateType: 'Basic',
                      contentIndex: index,
                    })
                  );
                }}
              />
            </div>
          </div>
        </div>
      </CoreModal>
    </>
  );
};

export default HtmlSwitchForEmail;
